import { render, staticRenderFns } from "./ScanToPay.vue?vue&type=template&id=722e57be&scoped=true&"
import script from "./ScanToPay.vue?vue&type=script&lang=ts&"
export * from "./ScanToPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e57be",
  null
  
)

export default component.exports